import { css } from 'styled-components';
import { ExpiredViewProps } from './models';

export const ExpiredView = css<ExpiredViewProps>(({ theme }) => {
  return css`
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
    height: 80%;
    color: ${theme.colors.primaryDeepBlue};

    > .description {
      display: flex;
      flex-direction: column;
      gap: 8px;
      height: 100%;
      align-items: center;
      max-width: 594px;

      @media only screen and ${theme.device.max.mobileXL} {
        gap: 12px;
      }

      > .title {
        font-weight: 600;
        font-size: 30px;
        line-height: 44px;
        white-space: pre-wrap;
        margin-top: 58px;

        @media only screen and ${theme.device.max.mobileXL} {
          font-size: 25px;
          line-height: 30px;
          max-width: 342px;
          padding-inline: 34px;
        }
      }

      > .subtitle {
        margin-top: 8px;
        font-size: 18px;
        line-height: 27px;
        font-weight: 500;
        white-space: break-spaces;

        @media only screen and ${theme.device.max.mobileXL} {
          margin-top: 12px;
          font-size: 16px;
          line-height: 21px;
          padding-inline: 50px;
        }
      }
    }
  `;
});
